/*
 * @Description: 众邦新增字段
 * @Date: 2021-11-02 10:16:19
 */
export default {
  data() {
    return {
      ruleForm: {
        companyBusinessAddress: '', // 营业执照注册地址
        companyBusinessStartDt: '', // 营业执照身份证有效期 开始时间  yyyy-MM-dd
        companyBusinessEndDt: '', // 营业执照身份证有效期 结束时间时间  yyyy-MM-dd （长期）
        legalPersonCardStartDt: '', // 法人身份证有效期 开始时间  yyyy-MM-dd
        legalPersonCardEndDt: '', // 法人身份证有效期 结束时间时间  yyyy-MM-dd （长期）
        transactorCardStartDt: '', // 经办人身份证有效期 开始时间  yyyy-MM-dd
        transactorCardEndDt: '' // 经办人身份证有效期 结束时间时间  yyyy-MM-dd （长期）
      },
      rules: {
        companyBusinessAddress: [
          {
            required: true,
            message: '请输入营业执照的注册地址',
            trigger: 'change'
          }
        ],
        companyBusinessStartDt: [
          {
            required: true,
            message: '请选择营业执照有效期日期',
            trigger: 'change'
          }
        ],
        companyBusinessEndDt: [
          {
            required: true,
            message: '请选择营业执照失效日期',
            trigger: 'change'
          }
        ],
        legalPersonCardStartDt: [
          {
            required: true,
            message: '请选择法人身份证有效期日期',
            trigger: 'change'
          }
        ],
        legalPersonCardEndDt: [
          {
            required: true,
            message: '请选择法人身份证失效日期',
            trigger: 'change'
          }
        ],
        transactorCardStartDt: [
          {
            required: true,
            message: '请选择经办人身份证有效期日期',
            trigger: 'change'
          }
        ],
        transactorCardEndDt: [
          {
            required: true,
            message: '请选择经办人身份证失效日期',
            trigger: 'change'
          }
        ]
      }
    };
  }
};
